import React from 'react';
import PropTypes from 'prop-types';
import { Map } from 'immutable';
import StructureFilter from '../StructureFilter';
import BarChartFilter from '../BarChartFilter';
import CheckboxFilter from '../CheckboxFilter';

import './FiltersByType.custom.scss';
import './FiltersByType.theme.scss';

const filtersMap = {
  5: StructureFilter,
  1: BarChartFilter,
  2: BarChartFilter,
  4: CheckboxFilter,
};

export default function FiltersByType(props) {
  const { filter } = props;
  const type = filter.get('type');
  const e2eId = filter.get('id').replace('.', '-');

  const Result = filtersMap[type];

  if (!Result) {
    Logger.error(`filter with type ${type} does not have template`);

    return null;
  }

  return (
    <li className={`filters-by-type e2e-filter ${e2eId}`}>
      <Result {...props} />
    </li>
  );
}

FiltersByType.propTypes = {
  filter: PropTypes.instanceOf(Map).isRequired,
  keyifyParamsForFiltersRequest: PropTypes.string.isRequired,
  context: PropTypes.string.isRequired,
};
